import type React from 'react';
import { Heading } from 'tradera/components/atoms/heading/heading';
import ALink from 'tradera/components/alink/alink';
import { Text } from 'tradera/components/atoms/text/text';
import TraderaCircleSVG from 'tradera/components/underage/headphones-sneakers.svg';
import styles from './underage.module.scss';
import { classNames } from 'tradera/utils/class-names';
import { useTranslator } from 'tradera/lang/translate';

type UnderageProps = {
    children?: React.ReactNode;
    onLinkClick?: () => void;
};

export const Underage = ({ children, onLinkClick }: UnderageProps) => {
    const { t } = useTranslator();

    return (
        <div className={classNames(styles.card, 'text-center')}>
            <img src={TraderaCircleSVG} alt="" />
            <Heading as="h3" className="mt-2" branded>
                {t('underage_heading')}
            </Heading>
            <Text className="mt-2">
                {t('underage_body')}{' '}
                <ALink
                    className="link"
                    href={t('underage_readMoreLink_href')}
                    onClick={onLinkClick}>
                    {t('underage_readMoreLink_label')}
                </ALink>
            </Text>
            {children}
        </div>
    );
};
